export const defaultPageSizes = [5, 20, 50, 100, 200, 500];
export const defaultPageSize = 100;
export const defaultSelectedPage = 1;
